import type { AuthUser } from '../types/api.js';

/**
 * LINE User ID Resolver にアクセス可能か判定する。
 *
 * アクセス可否は API 側（組織ロール = admin、または `app_access` の email 許可リスト）で
 * 評価された `canAccess` フラグを参照するのみ。
 *
 * @graph-stack line-user-id-resolver
 * @graph-domain Engineering
 * @graph-business API 側で評価された canAccess を返すだけのヘルパー。
 *   組織ロールと email 許可リストの両方を一貫して扱うため、Web でロジックを再実装しない。
 * @graph-connects none
 */
export function canAccessLineUserIdResolver(user: AuthUser | null | undefined): boolean {
  return user?.canAccess === true;
}
